import React from 'react';
import { motion } from 'framer-motion';
export function Agitation() {
  return <section className="bg-crema text-bordo py-20 px-4 md:px-8" data-id="element-10">
      <div className="max-w-3xl mx-auto space-y-6 text-lg md:text-xl text-gray-800" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-12">
          <p className="font-bold text-2xl md:text-3xl text-bordo mb-4" data-id="element-13">
            Porque el problema no es que no sepas cocinar.
          </p>
          <p className="font-bold text-2xl md:text-3xl text-bordo" data-id="element-14">
            El problema es que nadie te ordenó todo en un método simple.
          </p>
        </motion.div>

        <p data-id="element-15">Internet está lleno de recetas.</p>
        <p data-id="element-16">Pero eso no significa que ayude.</p>
        <p data-id="element-17">
          Pero después cerrás el celular, abrís la heladera y volvés al mismo
          punto:
        </p>

        <p className="font-serif text-2xl text-bordo italic text-center my-8" data-id="element-18">
          "¿Y ahora qué hago?"
        </p>

        <p className="font-bold" data-id="element-19">
          Necesitás saber qué corte comprar, cómo empanar, cómo cocinar, cómo
          combinar y cómo resolver una comida sin estresarte.
        </p>
      </div>
    </section>;
}